<template>
<div id="enroll-layout">
  <div id="enroll-main">
    <img src="/static/enroll-back.png" alt="" class="logo">
    <div class="city">—— 中国 · 深圳 ——</div>
    <div class="enroll">
      <div class="enroll-company">个人参会报名</div>
    </div>
    <div class="info">
      <h4>| 活动须知 |</h4>
      <p>
        为了您能顺利参加本次论坛，请按要求上传名片并填写信息。<br>
        格隆汇承诺参会信息仅用于本次活动联络需求，绝不对外公开。<br>
        若您在报名期间任何疑问，请联络格隆汇商务部。<br>
        商务部邮箱：business@gelonghui.com <br>
        商务部联系方式：0755-86332033
      </p>
    </div>
    <div id="ticket">
      <label for="name">门票选择
        <span class="data-form-required"> * </span>
      </label>
      <div class="ticket-box">
        <div :class="['ticket-zaoniao', 'ticket',ticket_action === '0'?'ticket-zaoniao-a action':'']">
          <div class="left">
            <div>
              <p class="ticket_name">早鸟票</p>
              <p class="sm">限量200张</p>
            </div>
            <p class="money"> <span style="font-size:12px;">￥</span>688.00</p>
          </div>
          <div class="right">
            <p style="font-size:12px;">申请数量</p>
            <div class="cant" v-if="ticket_action !== '0'"></div>
            <div class="ticketNumBox">
              <input type="button" value="-" @click="ticketNum(false)" class="buttom">
              <p class="num">{{ticket_action==='0'?form.ticketNum:'0'}}</p>
              <input type="button" value="+" @click="ticketNum(true)" class="buttom">
            </div>
          </div>
        </div>
      </div>
      <div class="ticket-box">
        <div :class="['ticket-youhui',' ticket',ticket_action === '1'?'ticket-youhui-a action':''] ">
          <div class="left">
            <div>
              <p class="ticket_name">优惠票</p>
              <p class="sm">限量200张</p>
            </div>
            <p class="money"> <span style="font-size:12px;">￥</span>888.00</p>
          </div>
          <div class="right">
            <p style="font-size:12px;">申请数量</p>
            <div class="cant" v-if="ticket_action !== '1'"></div>
            <div class="ticketNumBox">
              <input type="button" value="-" @click="ticketNum(false)" class="buttom">
              <p class="num">{{ticket_action==='1'?form.ticketNum:'0'}}</p>
              <input type="button" value="+" @click="ticketNum(true)" class="buttom">
            </div>
          </div>
        </div>
      </div>
      <div class="ticket-box">
        <div :class="['ticket-putong' ,'ticket',ticket_action === '2'?'ticket-putong-a action':'']">
          <div class="left">
            <div>
              <p class="ticket_name">普通票</p>
              <p class="sm">不限</p>
            </div>
            <p class="money"> <span style="font-size:12px;">￥</span>988.00</p>
          </div>
          <div class="right">
            <p style="font-size:12px;">申请数量</p>
            <div class="cant" v-if="ticket_action !== '2'"></div>            
            <div class="ticketNumBox">
              <input type="button" value="-" @click="ticketNum(false)" class="buttom">
              <p class="num">{{ticket_action==='2'?form.ticketNum:'0'}}</p>
              <input type="button" value="+" @click="ticketNum(true)" class="buttom">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-form">
      <div class="form-box">
        <label for="person">您的姓名
          <span class="data-form-required"> * </span>
        </label>
        <input type="text" v-model='form.person' class="input"/>  
      </div>
      <div class="form-box">
        <label for="phoneNum">手机
          <span class="data-form-required"> * </span>
        </label>
        <input type="text" v-model='form.phoneNum' class="input"/>
      </div>
      <div class="form-box">
        <label for="company">公司名称
          <span class="data-form-required"> * </span>
        </label>
        <input type="text" v-model='form.company' class="input"/>
      </div>
      <div class="form-box">
        <label for="position">您的职位
          <span class="data-form-required"> * </span>
        </label>
        <input type="text" v-model='form.position' class="input"/>
      </div>
      <div class="form-box">
        <label for="email">邮箱
          <span class="data-form-required"> * </span>
        </label>
        <input type="text" v-model.trim="form.email" class="input"/>
      </div>
      <div class="form-box">
        
      </div>
      <div class="form-box-card">
        <label for="card">您的名片
          <span class="data-form-required"> * </span>
        </label>
        <p style="font-size:12px;color:#fff;font-weight:100;">(支持 jpg,png,gif,bmp,tiff等图片格式)</p>
        <div class="carder-contanier">
          <el-upload 
          :action="oss.host" 
          :data='oss' 
          :on-success='onSuccess' 
          :on-remove='onRemove' 
          :on-progress='onUpload' 
          :on-error='onError'>
            <img v-if="form.card" :src="form.card" class="avatar">
            <div v-else class="el-icon-plus avatar-uploader-icon">
              上传名片
              <span class="data-form-required"> * </span>
            </div>
          </el-upload>
        </div>
      </div>
    </div>
    <div class="put">
      <input type="button" value="提交" @click="submitData">
    </div>
  </div>
  <div class="wxpay-model" v-if="wxpayShow">
    <div id="wxpay">
      <p class="pay-info">格隆汇2018年房地产高峰论坛</p>
      <p class="pay-info">{{form.phoneNum}}-{{form.person}}先生/女士，购买{{form.ticketType}}，{{form.ticketNum}}张,总计{{money}}元(RMB)</p>
      <div class="paying" v-if="wxpayIng">
        <div class="QR" v-if="onPc">
          <img src="https://tse3-mm.cn.bing.net/th?id=OIP.GtEo127m_vzHw4SOcz0B6gHaHa&w=199&h=200&c=7&o=5&dpr=1.25&pid=1.7" alt="">
          <p>请打开微信，扫码支付。</p>
        </div>
        <div class="inphone" v-if="onPhone">
          <div class="submit-button">
            <a :href="payUrl">进入微信支付</a>
            <!-- <button type="button" @click='wxpay'>进入微信支付</button> -->
          </div>
        </div>
      </div>
      <div class="pay-dong" v-if="wxpayDone">
        <p>报名成功！</p>
        <p>稍后您将会收到一条带有验证码的短信，请您妥善保管，切勿泄漏他人，届时将凭借验证码进入会场。</p>
        <p>验证码：{{ticketCode}}</p>
      </div>
    </div>

  </div>
</div>
</template>
<script>
import { Toast, Indicator, MessageBox } from "mint-ui";
import axios from "axios";
export default {
  data() {
    return {
      wxpayShow: false,
      wxpayIng: true,
      wxpayDone: false,
      onPc: false,
      onPhone: true,
      ticket_action: "0",
      creatId: "",
      payUrl: "",
      form: {
        acid: "1",
        company: "",
        person: "",
        position: "",
        phoneNum: "",
        email: "",
        card: "",
        ticketType: "",
        ticketTypePinyin: "",
        ticketNum: 0
      },
      oss: {
        key: "",
        OSSAccessKeyId: "",
        policy: "",
        Signatrue: "",
        host: "",
        success_action_status: 200,
        callback: ""
      },
      ticketInfo: [688, 888, 988]
    };
  },
  computed: {
    money() {
      return this.ticketInfo[this.ticket_action] * this.form.ticketNum;
    }
  },
  methods: {
    wxpay() {},
    ticketNum(isadd) {
      if (isadd) {
        this.form.ticketNum++;
      } else {
        if (this.form.ticketNum === 0) {
          return;
        }
        this.form.ticketNum--;
      }
    },
    getOssSign() {
      this.$http.oss_sign().then(res => {
        if (res.data.statusCode === 200) {
          this.oss.host = res.data.result.host;
          this.oss.key =
            res.data.result.dirPath + res.data.result.key + "${filename}";
          this.oss.policy = res.data.result.policy;
          this.oss.OSSAccessKeyId = res.data.result.OSSAccessKeyId;
          this.oss.Signature = res.data.result.Signature;
          this.oss.callback = res.data.result.callback;
        } else {
          this.$message({
            type: "error",
            message: "获取oss签名信息失败,请刷新重试。"
          });
        }
      });
    },
    onSuccess(res, file, filelist) {
      if (res.statusCode === 200) {
        this.form.card = `${this.oss.host}/${res.result.filename}`;
        Indicator.close();
      }
    },
    onRemove(res, file, filelist) {
      this.form.card = null;
    },
    onUpload(event, file, fileList) {
      Indicator.open("努力上传中...");
    },
    onError(err, file, fileList) {
      Toast("上传出错..." + err);
    },
    submitData() {
      this.wxpayShow = true;
      for (let key in this.form) {
        if (!this.form[key] === true) {
          Toast({
            message: "报名信息不全~",
            iconClass: "icon el-icon-warning"
          });
          return false;
        }
      }
      if (this.form.phoneNum.length !== 11 && this.form.phoneNum.length !== 8) {
        Toast({
          message: "请输入8位香港手机号,或者11位大陆手机号~",
          iconClass: "icon el-icon-warning"
        });
        return;
      }
      // 调用微信支付界面
      this.$http.creat_order_form({ ...this.form }).then(res => {
        if (res.data.statusCode === 200) {
          this.creatId = res.data.result.id;
        } else {
          Toast({
            message: "请检查您的网络后再试！",
            iconClass: "icon el-icon-warning"
          });
        }
      });
    },
    getActionInfo() {
      let id = 1;
      this.$http.estateforum_findbyid({ id }).then(res => {
        if (res.data.statusCode === 200) {
          this.ticket_action = res.data.result.ticketStatus;
          if (this.ticket_action === "0") {
            this.form.ticketType = "早鸟票";
            this.form.ticketTypePinyin = "zaoniaopiao";
          } else if (this.ticket_action === "1") {
            this.form.ticketType = "优惠票";
            this.form.ticketTypePinyin = "youhuipiao";
          } else {
            this.form.ticketType = "普通票";
            this.form.ticketTypePinyin = "putongpiao";
          }
        } else {
          Toast({
            message: "活动数据请求失败，请检查网络后再试。",
            iconClass: "icon el-icon-warning"
          });
        }
      });
    }
  },
  mounted() {
    this.getOssSign();
    this.getActionInfo();
  },
  created(){
  }
};
</script>

<style scoped>
#enroll-layout {
  width: 100%;
  background-color: #1e2a57;
}
#enroll-main {
  /* background-color: #1e2a57; */
  background: linear-gradient(47deg, #1e2a59 62%, #433f9f 83%);
  height: 100%;
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}
@media (max-width: 640px) {
  #enroll-main {
    background: linear-gradient(44deg, #1e2a59 77%, #433f9f 88%);
  }
}
.city {
  color: #fff;
  text-align: center;
  margin-top: -30px;
  font-size: 14px;
}
#enroll-main .logo {
  width: 100%;
}
.enroll {
  padding: 0 40px;
  display: flex;
  justify-content: space-around;
}
.enroll-company {
  margin-top: 20px;
  color: #fff;
  text-decoration: none;
  font-size: 18px;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  background-color: rgb(72, 69, 153);
}
.enroll-person {
  background-color: rgb(43, 103, 177);
}
.info {
  color: #fff;
  padding: 10px;
  padding-left: 20px;
  padding-right: 20px;
}
.info h4 {
  font-size: 16px;
  font-weight: 400;
  padding-bottom: 10px;
  border-bottom: 2px solid #fff;
  padding-top: 20px;
}
.info p {
  padding-top: 10px;
  padding-left: 0;
  padding-bottom: 0;
  font-size: 12px;
  font-weight: 100;
  line-height: 1.8em;
}
.info .mini {
  width: 68px;
}
.info .mid {
  width: 250px;
}
.data-form {
  padding: 0 20px;
  margin-top: 30px;
}
.data-form-required {
  color: #fff;
}
.data-form label {
  color: #fff;
  margin: 5px 0;
  display: block;
  font-weight: 200;
  font-size: 14px;
}
.data-form .form-box {
  margin: 0 auto;
  width: 335px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.data-form .form-box-card {
  width: 335px;
  margin: 0 auto;
}
.input {
  border-radius: 8px;
  height: 25px;
  font-size: 14px;
  color: #fff;
  background-color: rgb(30, 42, 89);
  border: 1px solid #fff;
  padding: 2px 8px;
  width: 200px;
  outline: none;
}
.put {
  display: flex;
  justify-content: center;
  padding: 40px;
}
.put input {
  background-color: #c8694a;
  border: none;
  padding: 5px 25px;
  padding-bottom: 8px;
  color: #fff;
  font-size: 22px;
  font-weight: 800;
  border-radius: 10px;
  outline: none;
}
.carder-contanier {
  overflow: hidden;
  width: 300px;
  height: 150px;
  margin: 10px auto;
  border: 1px solid #fff;
}

.el-upload {
  width: 300px;
  display: block;
}

.carder-contanier div,
.carder-contanier img {
  background: rgb(30, 42, 89);
  width: 300px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  margin: 0 auto;
  cursor: pointer;
}
.avatar-uploader-icon {
  color: #fff;
}
#ticket {
  color: #fff;
  font-size: 14px;
  font-weight: 100;
  padding: 0 20px;
}
.ticket {
  /* background: radial-gradient(circle at top left, transparent 20px, rgb(14, 92, 189) 0)
      top left,
    radial-gradient(circle at top right, transparent 20px, rgb(43, 103, 177) 0) top right,
    radial-gradient(circle at bottom right, transparent 20px, rgb(43, 103, 177) 0) bottom
      right,
    radial-gradient(circle at bottom left, transparent 20px, rgb(43, 103, 177) 0) bottom
      left; */
  background-size: cover;
  background-repeat: no-repeat;
  width: 330px;
  height: 154px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
}
.ticket-zaoniao {
  background-image: url("/static/ticket-1-f.fw.png");
  color: #ccc;
}
.ticket-youhui {
  background-image: url("/static/ticket-2-f.fw.png");
  color: #ccc;
}
.ticket-putong {
  background-image: url("/static/ticket-3-f.fw.png");
  color: #ccc;
}
.ticket-zaoniao-a {
  background-image: url("/static/ticket-1-a.fw.png");
  color: #fff;
}
.ticket-youhui-a {
  background-image: url("/static/ticket-2-a.fw.png");
  color: #fff;
}
.ticket-putong-a {
  background-image: url("/static/ticket-3-a.fw.png");
  color: #fff;
}
.ticket-box .left {
  width: 78%;
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.money {
  color: rgb(175, 175, 175);
  font-weight: 800;
  padding-bottom: 10px;
  margin-left: -5px;
}
.action .money {
  color: rgb(248, 183, 45);
}
.ticket-box .right {
  width: 22%;
  font-size: 0;
  padding-top: 85px;
  color: #fff;
  position: relative;
}
.ticketNumBox {
  display: flex;
}
.num {
  width: 18px;
  height: 18px;
  text-align: center;
  color: #ccc;
  background-color: rgb(30, 42, 89);
  border: 1px solid #ccc;
  border-left: none;
  border-right: none;
  outline: none;
  box-sizing: border-box;
  display: inline-block;
  font-size: 12px;
}
.buttom {
  border: none;
  box-sizing: border-box;
  width: 18px;
  height: 18px;
  background-color: rgb(30, 42, 89);
  color: #ccc;
  border: 1px solid #ccc;
  outline: none;
}
.action .num {
  color: #fff;
  border: 1px solid #fff;
  border-left: none;
  border-right: none;
}
.action .buttom {
  color: #fff;
  border: 1px solid #fff;
}
.cant {
  width: 64px;
  height: 25px;
  /* border: 1px solid #fff; */
  cursor: not-allowed;
  position: absolute;
  bottom: 31px;
  left: -6px;
}
.sm {
  font-size: 12px;
  font-weight: 100;
}
.ticket_name {
  padding-top: 5px;
  font-size: 14px;
  font-weight: 500;
}
.wxpay-model {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(185, 185, 185, 0.397);
}
#wxpay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  max-height: 400px;
  background-color: #fff;
  padding: 20px;
  border-radius: 15px;
}
#wxpay > p {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
}
#wxpay .QR {
  padding-top: 30px;
  text-align: center;
}
.QR img {
  width: 200px;
  height: 200px;
  margin-bottom: 20px;
}
.inphone .submit-button {
  padding: 15px;
}

.inphone .submit-button button {
  background: dodgerblue;
  color: #fff;
  width: 100%;
  border-radius: 5px;
  border: 0px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/frontend/estateforum/estateforum-person.vue